/**
 * The submit button for each form sits in the dialog footer, outside the `<form>` element,
 * and reaches it through the `form` attribute.
 *
 * They live here rather than beside their forms so that the footer can name a form without
 * importing the whole step component — RHF, zod and the mutation hook included — for the
 * sake of one string.
 */
export const SENTRY_REPORT_FORM_ID = "sentry-report-form";

export const SUPPORT_REQUEST_FORM_ID = "support-request-form";

export const CONTENT_REPORT_FORM_ID = "content-report-form";
